import axiosInstance from '../helpers/axiosInstance'

export const getManifest = async () => {
  try {
    const res = await axiosInstance.get(`/services/manifest`)
    return res.data
  } catch (e) {
    throw new Error(e)
  }
}